/**
* Social Links JS
* -----------------------------------------------------------------------------
*
* All the JS for the Social Links component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'social-links',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.newsletter-popup-trigger' ).magnificPopup( {
        items: [
          {
            src: '.social-links-popup',
            type: 'inline',
          },
        ],
        type: 'inline',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'social-links', COMPONENT );
} )( app );
